import React from "react";
import {
  FolderOpenOutlined,
  SnippetsOutlined,
  BarcodeOutlined,
  BankOutlined,
  FileTextOutlined,
  UserOutlined,
} from "@ant-design/icons";

const GroupMenu = [
  {
    key: "so",
    icon: <SnippetsOutlined />,
    title: "so",
    hasChildren: true,
  },
  {
    key: "report",
    icon: <FileTextOutlined />,
    title: "report",
    hasChildren: true,
  },
  {
    key: "prd_management",
    icon: <BarcodeOutlined />,
    title: "prd_management",
    hasChildren: true,
  },
  {
    key: "management",
    icon: <FolderOpenOutlined />,
    title: "management",
    hasChildren: true,
  },
  {
    key: "plant_management",
    icon: <BankOutlined />,
    title: "plant_management",
    hasChildren: true,
  },
  {
    key: "user",
    icon: <UserOutlined />,
    title: "user",
    hasChildren: true,
  },
];

const saleorderGroup = [
  {
    path: "/saleorders",
    module: "sale-order",
    sub_module: "saleorder",
    title: "admin_saleorder",
    group: "so",
    breadcrumb: [],
    matching_key: "sale_order",
  },
  {
    // สิทธิ์แยกจากรายการสั่งซื้อ ต้องมีแถว queue_refund ใน m_permissions
    // can_view เข้าหน้านี้ / can_edit ปุ่มลองใหม่ / can_delete ปุ่มปิดงาน
    path: "/refund-queue",
    module: "sale-order",
    sub_module: "refund-queue",
    title: "refund_queue",
    group: "so",
    breadcrumb: [],
    matching_key: "queue_refund",
  },
  {
    path: "/customer",
    module: "sale-order",
    sub_module: "customer",
    title: "customer",
    group: "so",
    breadcrumb: [],
    matching_key: "customer",
  },
];

const reportGroup = [
  // {
  //   path: "/expense-report",
  //   module: "report",
  //   sub_module: "account",
  //   title: "expense_report",
  //   group: "report",
  //   breadcrumb: [],
  //   matching_key: "expense_report",
  // },
  {
    path: "/rawdata-report",
    module: "report",
    sub_module: "saleorder",
    title: "rawdata_report",
    group: "report",
    breadcrumb: [],
    matching_key: "rawdata_report",
  },
  {
    path: "/wht-report",
    module: "report",
    sub_module: "wht",
    title: "wht_report",
    group: "report",
    breadcrumb: [],
    matching_key: "wht_report",
  },
];

const managementProduct = [
  {
    path: "/product",
    module: "product-management",
    sub_module: "product",
    title: "product",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "product",
  },
  {
    path: "/pricelist",
    module: "product-management",
    sub_module: "pricelist",
    title: "pricelist",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "pricelist",
  },
  {
    path: "/plant-product",
    module: "product-management",
    sub_module: "plant-product",
    title: "plant_product",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "plant_product",
  },
  {
    path: "/product-type",
    module: "product-management",
    sub_module: "product-type",
    title: "product_type",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "product",
  },
  {
    path: "/strength",
    module: "product-management",
    sub_module: "strength",
    title: "strength",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "strength",
  },
  {
    path: "/slump",
    module: "product-management",
    sub_module: "slump",
    title: "slump",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "slump",
  },
  {
    path: "/structure",
    module: "product-management",
    sub_module: "structure",
    title: "structure",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "structure",
  },
  {
    path: "/distance",
    module: "product-management",
    sub_module: "distance",
    title: "distance",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "distance",
  },
  {
    path: "/vehicletype-config",
    module: "product-management",
    sub_module: "vehicletype-config",
    title: "vehicle_type_config",
    group: "prd_management",
    breadcrumb: [],
    matching_key: "vehicle_type_config",
  },
];

const managementGroup = [
  {
    path: "/company",
    module: "master-data",
    sub_module: "company",
    title: "company",
    group: "management",
    breadcrumb: [],
    matching_key: "company",
  },
  {
    path: "/profile",
    module: "master-data",
    sub_module: "profile",
    title: "profile",
    group: "management",
    breadcrumb: [],
    matching_key: "profile",
  },

  {
    path: "/payment-channel",
    module: "master-data",
    sub_module: "payment",
    title: "payment_channel",
    group: "management",
    breadcrumb: [],
    matching_key: "payment_channel",
  },
  {
    path: "/faq",
    module: "master-data",
    sub_module: "faq",
    title: "faq",
    group: "management",
    breadcrumb: [],
    matching_key: "faq",
  },
  {
    path: "/sections",
    module: "master-data",
    sub_module: "section",
    title: "sections",
    group: "management",
    breadcrumb: [],
    matching_key: "sections",
  },
  {
    path: "/provinces",
    module: "master-data",
    sub_module: "provinces",
    title: "provinces",
    group: "management",
    breadcrumb: [],
    matching_key: "provinces",
  },
  {
    path: "/plant-accounts",
    module: "master-data",
    sub_module: "plant-account",
    title: "plant_accounts",
    group: "management",
    breadcrumb: [],
    matching_key: "plant_account",
  },

  {
    path: "/vat-cert",
    module: "master-data",
    sub_module: "vat-cert",
    title: "vat_cert",
    group: "management",
    breadcrumb: [],
    matching_key: "vat_cert",
  },
];

const PlantGroup = [
  {
    path: "/plant",
    module: "master-data",
    sub_module: "plant",
    title: "plant",
    group: "plant_management",
    breadcrumb: [],
    matching_key: "plant",
  },
  {
    path: "/plant-working-hour",
    module: "master-data",
    sub_module: "plant-working-hour",
    title: "plant_working_hour",
    group: "plant_management",
    breadcrumb: [],
    matching_key: "plant_working_hour",
  },
];

const userManagement = [
  {
    path: "/permission",
    module: "master-data",
    sub_module: "permission",
    title: "permission",
    group: "user",
    breadcrumb: [],
    matching_key: "permission",
  },
  {
    path: "/usergroup",
    module: "master-data",
    sub_module: "usergroup",
    title: "usergroup",
    group: "user",
    breadcrumb: [],
    matching_key: "usergroup",
  },
  {
    path: "/user",
    module: "master-data",
    sub_module: "user",
    title: "user",
    group: "user",
    breadcrumb: [],
    matching_key: "user",
  },
];

const ListMenu = [
  ...saleorderGroup,
  ...reportGroup,
  ...managementProduct,
  ...managementGroup,
  ...PlantGroup,
  ...userManagement,
];

export { GroupMenu, ListMenu };
